export enum CallbackID {
  WEB_LOSS = 4,
  SET_TOKEN = 5,
  SET_MODEL = 6,
  GET_DIALOGUE_HISTORY = 10,
  EDIT_DIALOGUE = 12,
  DELETE_CHAT = 13,
  GET_CHAT_HISTORY = 14,
  SAVE_DIALOGUE = 15,
  DELETE_DIALOGUE = 16,
  OPEN_BUY_VIP = 17,
  MB_SIZE = 18,
}

export interface CallbackItem {
  id: CallbackID;
  func: (data: any) => void;
}

const callbackRegistry: CallbackItem[] = [];

export function useCallbackRegistry() {
  const findCallbackById = (id: CallbackID): CallbackItem | undefined => {
    return callbackRegistry.find((c) => c.id === id);
  };

  const removeExistingCallback = (id: CallbackID): void => {
    const index = callbackRegistry.findIndex((c) => c.id === id);
    if (index > -1) {
      callbackRegistry.splice(index, 1);
    }
  };

  const addNewCallback = (item: CallbackItem) => {
    callbackRegistry.push(item);
  };

  const registerCallback = (item: CallbackItem): void => {
    removeExistingCallback(item.id);
    addNewCallback(item);
  };

  return {
    callbackRegistry,
    findCallbackById,
    registerCallback,
  };
}
